"use strict";
exports.__esModule = true;
exports.SET_ACTIVE_PARTNERS = exports.SET_PIPELINE_VERSION = exports.SET_VIA_NAME = exports.SET_BUSINESS_ID = void 0;
exports.SET_BUSINESS_ID = 'business.SET_BUSINESS_ID';
exports.SET_VIA_NAME = 'business.SET_VIA_NAME';
exports.SET_PIPELINE_VERSION = 'business.SET_PIPELINE_VERSION';
exports.SET_ACTIVE_PARTNERS = 'business.SET_ACTIVE_PARTNERS';
